"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultChainId = exports.testChainId = exports.availableChains = exports.ns = exports.companyName = void 0;
exports.companyName = "Cascadify Portal";
exports.ns = "portal";
exports.availableChains = [1, 5, 56, 97, 137, 80001, 42161, 13377, 13378];
exports.testChainId = 13378n;
exports.defaultChainId = 56n;
//# sourceMappingURL=company.js.map